module.exports = __webpack_public_path__ + "static/media/university-college-dublin.a89ab3d2.jpg";